import React from 'react'
import { useTranslation } from 'react-i18next'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Modal from '../../../components/structure/Modal'
import Text from '../../../packages/kiti/components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import LabelValue from '../../../packages/kiti/components/presentation/LabelValue'
import { formatDate } from '@btime/helpers'
import Content from './Content'
import { PanelContent } from '../../../components/structure/Panel'

const AuditDetail = ({ data, onClose }) => {
  const { t } = useTranslation('audit')
  const getOperation = operation => {
    if (operation === 'create') return t('operations.create')
    if (operation === 'update') return t('operations.update')
    return t('operations.remove')
  }

  return (
    <Modal open={true} width="35rem" onClose={onClose} noPadding>
      <Separator padding={0.5} bgColor="dark1">
        <Text bold align="center" color="white">
          {t('operationDetails')}
        </Text>
      </Separator>
      <PanelContent>
        <FlexGrid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
          <FlexCol width="50%">
            <LabelValue label={t('fields.createdBy')}>{data.createdBy?.name}</LabelValue>
          </FlexCol>
          <FlexCol width="50%">
            <LabelValue label={t('date')}>{formatDate('DD/MM/YYYY HH:mm')(data.insertedAt)}</LabelValue>
          </FlexCol>
          <FlexCol width="50%">
            <LabelValue label={t('operation')}>{getOperation(data.operation)}</LabelValue>
          </FlexCol>
        </FlexGrid>
        <Separator weight={4} />
        <Content data={data} />
      </PanelContent>
    </Modal>
  )
}

export default AuditDetail
